<template>
    <div>
        <form class='endorsed-modal__dms__form'>
            <button type='submit'><svg class='search'><use xlink:href="#search"></use></svg></button>
            <input type="text" v-model="search" placeholder="Search">
        </form>
        <div class="endorsed-modal-list">
            <span v-if="allUsers.length == 0">No results. Please try another search term.</span>
            <a href="#" v-on:click="createConversation(user_convo)" v-for="user_convo in allUsers" :value="user.id" v-if="user_convo.id != user.id">
                <img v-bind:src="user_convo.profile_thumbnail" data-rjs="2">
                {{user_convo.first_name}} {{user_convo.last_name}}<svg v-if="user_convo.is_verified" class='verified-badge' aria-labelledby="badgeTitle">
                            <title id="badgeTitle">Well Traveled Insider</title>
                            <use xlink:href="#verified-badge"><title id="badgeTitle">Well Traveled Insider</title></use>
                        </svg>
            </a>
        </div>
    </div>
</template>

<script>
    import { eventBus } from "../../dms";
    import {debounce} from "lodash";

    export default {
        props: ['iuser'],

        data() {
            return {
                search: '',
                users: [],
                allUsers: [],
                initialUsers: [],
                user: {}
            }
        },
        watch: {
            search: function (newSearch, oldSearch) {
                if (newSearch.length === 0) {
                    this.allUsers = this.initialUsers;
                    eventBus.$emit('formIsEmpty');
                    return;
                }

                if (newSearch.length >= 3) this.handleSearch()
            }
        },

        created() {
            if (this.$route.query.conversation) {
                axios.post('/conversations-get-user', {user: this.$route.query.conversation})
                    .then((response) => {
                        if (response.data) {
                            this.users = [response.data[0].id];
                            eventBus.$emit('createConversation', this.users);
                            this.$route.query.conversation = '';
                        }
                    });
            }
        },

        mounted() {

            this.user = this.iuser;

            axios.get('/get-conversation-users')
                .then((response) => {
                    this.allUsers = response.data;
                    this.initialUsers = response.data
                });
        },

        methods: {
            createConversation(user) {
                this.users = [user.id];
                eventBus.$emit('createConversation', this.users);
            },
            handleSearch: debounce(function () {
                if (this.search.length == 0)
                    this.allUsers = this.initialUsers
                else {
                    axios.post('/conversations-user-search', {search: this.search})
                        .then((response) => {
                            this.allUsers = response.data
                        });
                }
            }, 500),
        },
    }
</script>
